import React, { useEffect, useState } from 'react';
import './index.less';
import Container from '@/components/container';
import classname from 'classnames';

export default (props) => {
  let {
    border = false,
    style = {},
    shadow = false,
    className = '',
    backgroundColor = false,
    container = {},
    hoverBorder = false,
    ...othersProps
  } = props;
  border = border && '1px solid #d9d9d9';
  backgroundColor = backgroundColor && '#fafafa';
  if (typeof shadow == 'boolean') {
    shadow ? (shadow = 'middle') : (shadow = 'no');
  }
  const wrapClass = classname({
    TY__card: true,
    [className]: true,
    [`${shadow}_shadow`]: true,
    add_hover_border: hoverBorder,
  });

  return (
    <div {...othersProps} className={`${wrapClass}`} style={{ backgroundColor, border, ...style, borderRadius: '8px' }}>
      <Container {...container} bg={false} style={{ height: '100%' }}>
        <div className="TY__card--content">{props.children}</div>
      </Container>
    </div>
  );
};
